// extracted by mini-css-extract-plugin
module.exports = {"nudge":"_8445449","badgeText":"_b6d367b"};